import { useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { useAuth } from '../context/AuthContext';
import { UserRoles } from 'store/models/User';
import { GET_USER_INFO } from 'store/graphql/queries/GET_USER_INFO';
import { isVendorRole } from 'utils/isVendorRole';
import { isRoleAllowed } from 'utils/isRoleAllowed';
import { isMemberRole } from 'utils/isMemberRole';
import { PrivateRoute } from 'constants/routes';
import { Loader } from './Loader';

interface ProtectedUserRouteProps {
  userRoles: UserRoles[];
}

const ProtectedUserRoute = ({ userRoles }: ProtectedUserRouteProps) => {
  const { currentUserRoles, setCurrentUserRoles } = useAuth();
  const isAllowed = isRoleAllowed(userRoles, currentUserRoles);
  const isVendor = isVendorRole(currentUserRoles);
  const isMember = isMemberRole(currentUserRoles);

  const { loading, data } = useQuery(GET_USER_INFO, {
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'cache-first',
  });

  useEffect(() => {
    if (!loading && data) {
      setCurrentUserRoles(data?.getUserInfo?.roles || null);
    }
  }, [data]);

  return (
    <>
      {!loading && isAllowed && <Outlet />}
      {!loading && !isAllowed && isVendor && <Navigate to={PrivateRoute.VendorDashboard} replace />}
      {!loading && !isAllowed && isMember && <Navigate to={PrivateRoute.MemberDashboard} replace />}
      {loading && (
        <div style={{ backgroundColor: '#fff', width: '100%', height: '100vh' }}>
          <Loader />
        </div>
      )}
    </>
  );
};

export default ProtectedUserRoute;
